module.exports = __webpack_public_path__ + "img/arduino.f895f760.png";